/**
 * Reusable Confirm Modal Component
 * Displays a confirmation dialog with custom title, message, and actions
 */

import React, { useId } from "react";
import ReactDOM from "react-dom";
import useEscapeKey from "../../hooks/useEscapeKey";

const ConfirmModal = ({
  isOpen,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  extraText,
  onConfirm,
  onCancel,
  onExtra,
  isLoading = false,
  isDanger = false,
  hideCancel = false,
}) => {
  const titleId = useId();
  // Escape dismisses the dialog like Cancel (or OK for single-button alerts)
  useEscapeKey(isOpen && !isLoading, () => {
    if (onCancel) onCancel();
    else if (hideCancel && onConfirm) onConfirm();
  });

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="confirm-modal-overlay" role="dialog" aria-modal="true" aria-labelledby={titleId}>
      <div className="confirm-modal">
        <div className="confirm-modal-header">
          <h3 className="confirm-modal-title" id={titleId}>{title}</h3>
        </div>
        <p className="confirm-modal-text">{message}</p>
        <div className="confirm-modal-actions">
          {!hideCancel && (
            <button
              type="button"
              className="confirm-btn cancel"
              onClick={onCancel}
              disabled={isLoading}
            >
              {cancelText}
            </button>
          )}
          {extraText && onExtra && (
            <button
              type="button"
              className="confirm-btn"
              onClick={onExtra}
              disabled={isLoading}
              style={{ background: 'linear-gradient(135deg, #475569, #334155)', color: '#e2e8f0' }}
            >
              {extraText}
            </button>
          )}
          <button
            type="button"
            className={`confirm-btn ${isDanger ? "danger" : ""}`}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmModal;
